// React
import { useMemo } from 'react';

// Shared components
import { DataTableTabs } from '@components/DataTable/DataTableTabs';

// Hooks
import { useTranslation } from '@hooks/useTranslation';

// Types
import type { TranslationObject } from '@hooks/useTranslation';
import type { EventsTabsProps, EventTab, EventTabConfig } from '../types';
import { EVENT_TAB_VALUES } from '../types';

export type { EventsTabsProps };

function buildTabs(tabTranslations?: TranslationObject): EventTabConfig[] {
  return EVENT_TAB_VALUES.map((tab) => ({
    key: tab,
    label: (tabTranslations?.[tab] as string) ?? tab,
  }));
}

export function EventsTabs({
  currentTab,
  onTabChange,
  disabled = false,
  className,
}: EventsTabsProps) {
  const { getSection } = useTranslation();
  const tabTranslations = getSection('tabs');
  const tabs = useMemo(() => buildTabs(tabTranslations), [tabTranslations]);

  return (
    <DataTableTabs<EventTab>
      tabs={tabs}
      value={currentTab}
      onValueChange={onTabChange}
      disabled={disabled}
      className={className}
    />
  );
}
